import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class StorageService {
  save<T>(key: string, data: T): void {
    try {
      localStorage.setItem(key, JSON.stringify(data));
    } catch (error) {
      console.error(`Error al guardar en localStorage: ${error}`);
      throw new Error('No se pudo guardar en localStorage');
    }
  }

  load<T>(key: string): T | null {
    try {
      const data = localStorage.getItem(key);
      if (data) {
        return JSON.parse(data) as T;
      }
      return null;
    } catch (error) {
      console.error(`Error al cargar de localStorage: ${error}`);
      return null;
    }
  }

  getOrCreate<T>(key: string, defaultValue: T): T {
    try {
      const existingData = this.load<T>(key);
      if (existingData !== null) {
        return existingData;
      }
      this.save(key, defaultValue);
      return defaultValue;
    } catch (error) {
      console.error(`Error al verificar o crear en localStorage: ${error}`);
      return defaultValue;
    }
  }

  clear(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(`Error al eliminar de localStorage: ${error}`);
    }
  }

  clearAll(): void {
    try {
      localStorage.clear();
    } catch (error) {
      console.error(`Error al limpiar localStorage: ${error}`);
    }
  }
}
